import { render, staticRenderFns } from "./ruleSetting.vue?vue&type=template&id=3bb85d4c&scoped=true"
import script from "./ruleSetting.vue?vue&type=script&lang=js"
export * from "./ruleSetting.vue?vue&type=script&lang=js"
import style0 from "./ruleSetting.vue?vue&type=style&index=0&id=3bb85d4c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bb85d4c",
  null
  
)

export default component.exports